import CertificateModalElement from './CertificateModalElement';
import { CertificateData } from './GiftCertificates';

export default class CertificateModal {
  private modalWindow: CertificateModalElement | null = null;

  private isOpen = false;

  open(data: CertificateData): void {
    if (this.isOpen) return;
    this.modalWindow = new CertificateModalElement(data);

    document.body.append(this.modalWindow.node);
    this.isOpen = true;

    this.modalWindow.closeBtn.node.addEventListener('click', this.close);
    this.modalWindow.node.classList.add('active');

    const scrollPos = window.scrollY;
    document.body.dataset.scrollPos = `${scrollPos}`;
    document.body.classList.add('body-no-scroll-total');
    document.body.style.top = `-${scrollPos}px`;

    // Только pointerdown по самому оверлею: при выделении текста в поле и отпускании мыши над фоном
    // срабатывает click на document/оверлее — модалка не должна закрываться (mousedown был в поле).
    const overlay = this.modalWindow.node.querySelector('.cert-modal__overlay');
    overlay?.addEventListener('pointerdown', this.onOverlayPointerDown);
  }

  close = (): void => {
    if (!this.modalWindow) return;
    this.modalWindow.node.classList.remove('active');

    document.body.classList.remove('body-no-scroll-total');
    document.body.style.removeProperty('top');
    const scrollPos = Number(document.body.dataset.scrollPos || '0');
    window.scrollTo({ top: scrollPos, left: 0, behavior: 'instant' });

    const overlay = this.modalWindow.node.querySelector('.cert-modal__overlay');
    overlay?.removeEventListener('pointerdown', this.onOverlayPointerDown);
    this.modalWindow.closeBtn.node.removeEventListener('click', this.close);
    this.modalWindow.delete();
    this.modalWindow = null;
    this.isOpen = false;
  };

  private onOverlayPointerDown = (e: Event): void => {
    if (e.target !== e.currentTarget) return;
    e.preventDefault();
    this.close();
  };
}
